












import { Component, Vue } from 'vue-property-decorator'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'

@Component
export default class HospitalTermsOfUseView extends Vue {
  hospitalTermsOfUseFileSource: string = ''

  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  async created() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando...' })

    await this.openHospitalUseTerms()

    EventBus.$emit('clearLoadingRequest')
  }

  async openHospitalUseTerms() {
    try {
      const hospitalTermsOfUseData = await this.getSolicitacaoStore.getHospitalTermsOfUse(this.$route.params.hospitalId)
      const hospitalTermsOfUseFileData = hospitalTermsOfUseData.file

      const base64String = hospitalTermsOfUseFileData
      const byteCharacters = atob(base64String)

      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }

      const byteArray = new Uint8Array(byteNumbers)

      const fileBlob = new Blob([byteArray], { type: 'application/pdf' })
      const fileURL = URL.createObjectURL(fileBlob)

      this.hospitalTermsOfUseFileSource = fileURL
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao carregar termos de uso, tente novamente.', icon: 'warning', color: '#C62828' })
    }
  }
}
